<template>
  <div class="version-history-tab">
    <div v-if="loading" class="text-muted small py-2">読み込み中...</div>
    <div v-else-if="error" class="text-danger small py-2">{{ error }}</div>
    <div v-else-if="!versions.length" class="text-muted small py-2">
      バージョン履歴がありません。
    </div>
    <ul v-else class="list-group list-group-flush">
      <li
        v-for="(version, index) in versions"
        :key="version.id"
        class="list-group-item d-flex justify-content-between align-items-start"
      >
        <div class="mr-2">
          <div class="font-weight-bold text-break">
            <span v-if="index === 0" class="badge badge-primary mr-1">最新</span>
            <span v-if="isSelectedVersion(version)" class="badge badge-success mr-1">
              選択中
            </span>
            ID:
            <button
              v-if="!version.deleted_at"
              type="button"
              class="btn btn-link p-0 align-baseline"
              @click="requestSelect(version)"
            >
              {{ version.id }}
            </button>
            <span v-else class="text-muted" title="ゴミ箱">
                <span style="text-decoration: line-through;">{{ version.id }}</span>
                <span class="small ml-1">(ゴミ箱)</span>
            </span>
          </div>
          <div class="text-muted small">
            {{ version.created_at || '-' }}
            <span v-if="version.upload_filesize">・{{ formatSize(version.upload_filesize) }}</span>
          </div>
          <div v-if="version.uploader_name" class="text-muted small">
            アップロード: {{ version.uploader_name }}
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'VersionHistoryTab',
  emits: ['request-select'],
  props: {
    videoId: { type: Number, required: true },
    selectedVersionId: { type: [Number, String], default: null },
  },
  data() {
    return {
      versions: [],
      loading: false,
      error: null,
    };
  },
  watch: {
    videoId: {
      immediate: true,
      handler() {
        this.fetchVersions();
      },
    },
  },
  methods: {
    async fetchVersions() {
      if (!this.videoId) {
        this.versions = [];
        return;
      }
      this.loading = true;
      this.error = null;
      try {
        const response = await window.axios.get(`/api/videos/${this.videoId}/versions`);
        const payload = response?.data?.versions ?? response?.data ?? [];
        this.versions = Array.isArray(payload) ? payload : [];
      } catch (error) {
        this.error =
          error?.response?.data?.message || 'バージョン履歴を取得できませんでした。';
      } finally {
        this.loading = false;
      }
    },
    requestSelect(version) {
      if (!version || !version.id) {
        return;
      }
      this.$emit('request-select', version);
    },
    isSelectedVersion(version) {
      if (!version || version.id === null || version.id === undefined) {
        return false;
      }
      if (this.selectedVersionId === null || this.selectedVersionId === undefined) {
        return false;
      }
      return String(version.id) === String(this.selectedVersionId);
    },
    formatSize(bytes) {
      const size = Number(bytes);
      if (!Number.isFinite(size)) {
        return '-';
      }
      if (size <= 0) {
        return '0B';
      }
      const units = ['B', 'KB', 'MB', 'GB', 'TB'];
      let value = size;
      let index = 0;
      while (value >= 1024 && index < units.length - 1) {
        value /= 1024;
        index++;
      }
      const rounded = value < 10 && index > 0 ? value.toFixed(1) : Math.round(value);
      return `${rounded}${units[index]}`;
    },
  },
};
</script>
